@let displayPrice = discountedPrice() ?? price();

<section class="flex items-center justify-center">
  <h3 id="product-card-price-title" class="sr-only">{{ ['a11y', 'product_card_sr_title'] | translate }}</h3>
  <div class="flex items-end gap-1.5" aria-labelledby="product-card-price-title">
    <span
      class="text-sm text-[--color-text-icon-secondary] -rotate-90 self-end"
      [ngClass]="{
        'mb-4': isOfferBox(),
        'mb-3': !isOfferBox(),
        'group-[.custom-theme]/body:text-[--basic-white]': isNavProduct(),
      }"
      aria-hidden="true"
      >CHF</span
    >
    <span
      class="text-[--color-text-primary] text-7xl font-extrabold leading-none"
      [ngClass]="{ 'text-featured': discountedPrice(), 'md:text-8xl': isOfferBox() }"
      [attr.aria-label]="['a11y', 'product_card_price_per_month'] | translate | replaceToken: { displayPrice }"
      >{{ displayPrice }}</span
    >
    <div class="text-[--color-text-icon-secondary] text-sm text-left mb-2 pl-1 flex flex-col">
      @if (discountLabel() && !brandService.isChmobile()) {
        <lib-badge [label]="discountLabel()" class="mb-1" />
      }
      @if (discountedPrice()) {
        <div>
          <span
            class="text-[--color-text-icon-secondary] text-sm crossed-out leading-4"
            [ngClass]="{ 'group-[.custom-theme]/body:text-[--basic-white]': isNavProduct() }"
            [attr.aria-label]="['a11y', 'product_card_original_price'] | translate | replaceToken: { price: price() }"
            >{{ price() }}</span
          >
        </div>
      }
      <span
        class="leading-4"
        [ngClass]="{ 'group-[.custom-theme]/body:text-[--basic-white]': isNavProduct() }"
        aria-hidden="true"
        >{{ ['product_card_month'] | translate }}</span
      >
    </div>
  </div>
</section>
